import {variables} from "../config_variables/variables";

function createDummyGridBox (count) {

                let out_map = {}
                for(let i = 0 ; i < count ; i++) {
                                out_map ['dummygridbox'+i] = 0
                }

                return out_map
}

export default createDummyGridBox